<template>
  <section
    class="provenues-banner-container px-[45px]"
    :class="hasPadding ? 'xl:px-[206.9px]' : '2xl:px-[206px]'"
  >
    <img
      src="@/assets/images/logo-wegowprovenues.svg"
      class="md:w-[282px] w-[107px] mx-auto md:mb-12 mb-[10.8px]"
      alt="Wegow Provenues logo"
    />
    <div
      class="provenues-banner-container__title"
      :class="
        hasPadding
          ? '2xl:px-[200px]'
          : 'provenues-banner-container__title--special-font'
      "
    >
      <p class="provenues-banner-container__info">
        {{ $t("wegow.banner.provenues.title") }}
      </p>
    </div>
    <div class="mx-auto">
      <wegow-button
        button-id="banner-provenues-button"
        background="opacity"
        :text="$t('wegow.banner.provenues.btn')"
        color="topaz-light"
        type="button"
        size="banner-xl"
        @click="navigateTo"
      />
    </div>
  </section>
</template>

<script setup>
import WegowButton from "@/components/general/forms/WegowButton";

const props = defineProps({
  hasPadding: {
    type: Boolean,
    default: false
  }
});
const navigateTo = () => {
  window.open("https://www.wegowprovenues.com/", "_blank");
};
</script>

<style lang="scss" scoped>
.provenues-banner-container {
  height: 129px;
  background-image: url("@/assets/images/bg_banner_provenues.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  padding-bottom: 11px;
  @supports (
    background-image: url("@/assets/images/bg_banner_provenues.webp")
  ) {
    background-image: url("@/assets/images/bg_banner_provenues.webp");
  }
  @media screen and (min-width: $screen-md) {
    height: 370px;
    padding-top: 41.5px;
    padding-bottom: 64px;
  }
  &__title {
    font-size: 12px;
    line-height: normal;
    @media screen and (min-width: $screen-md) {
      font-size: 40px;
      line-height: 48px;
    }
    &--special-font {
      @media screen and (min-width: $screen-md) and (max-width: 1575px) {
        font-size: 30px;
        line-height: normal;
      }
    }
  }
  &__info {
    margin-bottom: 11px;
    text-wrap: pretty;
    @media screen and (min-width: $screen-md) {
      margin-bottom: 48px;
    }
  }
}
</style>
